var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("el-alert", {
    attrs: {
      title: _vm.$t("interchangeEventDetail.noInterpreted"),
      type: "info",
      closable: false,
      "show-icon": "",
      "data-channel": _vm.row.interchange_channel
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }